module.exports = "pegasus/assets/theme3/google.png";